export const EShapeActionValueOpetyped = wcardinal.ui.EShapeActionValueOpetyped;